import LocalizedEditorialPage from '../../../components/LocalizedEditorialPage'
import { locales, isLocale } from '../../../translations/config'
import getEditorialPage from '../../../translations/getEditorialPage'

export default function Guides({ locale, editorialPage, editorialReviewedLabel }) {
  return <LocalizedEditorialPage locale={locale} slug='guides' page={editorialPage} reviewedLabel={editorialReviewedLabel} />
}

export async function getStaticProps({ params }) {
  const locale = isLocale(params.lang) ? params.lang : 'en'
  return { props: { locale, ...getEditorialPage(locale, 'guides') } }
}

export async function getStaticPaths() {
  return { paths: locales.map(lang => ({ params: { lang } })), fallback: false }
}
